export const appGroupsAppGroupIdPlacementsIdPreview = "/app_groups/:app_group_id/placements/:id/preview";
